import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Home.module.css";

import {
  categoryImages,
  brands,
  certificates,
  statsData,
  references,
} from "./homeData";

import Slider from "./Slider/Slider";
import SlideContent from "./Slider/components/SlideContent";
import Brands from "./Brands/Brands";
import Certificates from "./Certificates/Certificates";
import Stats from "./Stats/Stats";
import MapSection from "./MapSection/MapSection";
import References from "./References/References";

const Home = () => {
  const navigate = useNavigate();

  // Transform categoryImages into the format expected by the new slider
  const slides = categoryImages.map(item => ({
    content: (
      <SlideContent
        title={item.name}
        description={item.description}
        videoUrl={item.image}
        webmUrl={item.webm}
        imageUrl={item.image}
        poster={item.poster}
      />
    )
  }));

  return (
    <div className={styles.homeContainer}>
      <section className={styles.sectionWrapper} data-aos="fade-right" data-aos-duration="800">
        <Slider slides={slides} />
      </section>
      <section className={styles.sectionWrapper} data-aos="fade-left" data-aos-delay="200">
        <Brands items={brands} />
      </section>
      <section className={styles.sectionWrapper} data-aos="fade-up" data-aos-delay="400">
        <Certificates items={certificates} />
      </section>
      
      {/* CATALOG & DOCUMENTS CTA */}
      <section className={styles.sectionWrapper} data-aos="fade-right" data-aos-delay="600">
        <div className={styles.ctaContainer}>
          <p className={styles.ctaText}>
            Ürün kataloglarımızı ve belgelerimizi incelemek için aşağıdaki
            butonlara tıklayınız.
          </p>
          <div className={styles.ctaButtons}>
            <button
              className={styles.ctaButton}
              onClick={() => navigate('/catalog')}
            >
              <i className="fas fa-book-open" /> Kataloglarımız
            </button>
            <button
              className={styles.ctaButton}
              onClick={() => navigate('/documents')}
            >
              <i className="fas fa-file-alt" /> Belgelerimiz
            </button>
          </div>
        </div>
      </section>
      <section className={styles.sectionWrapper} data-aos="fade-left" data-aos-delay="800">
        <Stats data={statsData} />
      </section>
      <section className={styles.sectionWrapper} data-aos="fade-up" data-aos-delay="1000">
        <MapSection />
      </section>
      <section className={styles.sectionWrapper} data-aos="fade-up">
        <References references={references} />
      </section>
    </div>
  );
};

export default Home;
